import { ConfirmDialog } from '@/components/modals/ConfirmationModal';
import { ModalsManager } from '@/components/modals/modalsManager';

export const confirmIntegrationDisconnect = async (
  name: string,
  disconnect: () => void | Promise<void>
) => {
  const confirmed = await ModalsManager.showResolvable(ConfirmDialog, {
    title: `Disconnect ${name}?`,
    description: `Littlebird will no longer be able to use ${name}.`,
    confirmText: 'Disconnect',
  });
  if (!confirmed) return;

  await disconnect();
};
